// extracted by mini-css-extract-plugin
export default {"card":"WalletCard_card__KzzE+","title":"WalletCard_title__f6Yca","icon":"WalletCard_icon__bLgey"};